<template>
    <div class="accept-content">
        <accept-header :title="acceptCurrent.title"></accept-header>
        <accept-body :paragraphs="acceptCurrent.paragraphs"></accept-body>
        <accept :nextRoute="acceptCurrent.nextRoute"></accept>
    </div>
</template>
<script>
import acceptHeader from './acceptHeader.vue'
import acceptBody from './acceptBody.vue'
import accept from './accept.vue'

export default {
    components : {
        acceptHeader,
        acceptBody,
        accept
    },
    props : {
        acceptCurrent : {
            
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
